<template>
  <div
    class="modal"
    :class="{ visible: Visible, loading: Loading }"
    @click="Close($event)"
  >
    <div v-if="Mode == 'Option'" class="modal__option">
      <Transition name="fade">
        <iframe
          v-if="Element != ''"
          @load="Loading = false"
          :src="RequireElement(Mode, Element)"
          frameborder="0"
          class="modal__option__item"
        ></iframe
      ></Transition>
    </div>
    <div v-else-if="Mode == 'Detalle'" class="modal__image">
      <Transition name="fade">
        <img
          v-if="Element != ''"
          @load="Loading = false"
          :src="RequireElement(Mode, Element)"
          alt=""
          class="modal__image__item"
        />
        ></Transition
      >
    </div>
    <div v-else-if="Mode == 'Share'" class="modal__share">
      <div class="modal__share__items">
        <div
          @click="CopyToClipboard()"
          class="modal__share__items__item"
          style="background-color: rgb(180, 180, 180)"
        >
          <i class="icon-copy"></i>
        </div>
        <vue-goodshare-email
          class="modal__share__items__item"
          :page_url="Element"
          has_icon
        ></vue-goodshare-email>
        <vue-goodshare-linkedIn
          class="modal__share__items__item"
          :page_url="Element"
          has_icon
        ></vue-goodshare-linkedIn>
        <vue-goodshare-twitter
          class="modal__share__items__item"
          :page_url="Element"
          has_icon
        ></vue-goodshare-twitter>
        <vue-goodshare-whatsApp
          class="modal__share__items__item"
          :page_url="Element"
          has_icon
        ></vue-goodshare-whatsApp>
      </div>
    </div>
  </div>
</template>

<script>
import VueGoodshareEmail from "vue-goodshare/src/providers/Email.vue";
import VueGoodshareLinkedIn from "vue-goodshare/src/providers/LinkedIn.vue";
import VueGoodshareTwitter from "vue-goodshare/src/providers/Twitter.vue";
import VueGoodshareWhatsApp from "vue-goodshare/src/providers/WhatsApp.vue";

export default {
  name: "Modal",
  components: {
    VueGoodshareEmail,
    VueGoodshareLinkedIn,
    VueGoodshareTwitter,
    VueGoodshareWhatsApp,
  },
  data() {
    return {
      Visible: false,
      Element: "",
      Mode: "",
      Loading: true,
    };
  },
  mounted() {
    this.SetVisible();
  },
  methods: {
    CopyToClipboard() {
      var aux = document.createElement("input");
      aux.style.zIndex = "-9999999999999";
      aux.style.pointerEvents = "none";
      aux.style.opacity = "0";
      aux.style.position = "absolute";
      aux.setAttribute("value", this.Element);
      document.body.appendChild(aux);
      aux.select();
      document.execCommand("copy");
      document.body.removeChild(aux);
      this.Visible = false;
      this.$root.$emit("Visible");
      setTimeout(() => {
        this.Loading = true;
        this.Element = "";
      }, 250);
    },
    Close(e) {
      var element;
      if (e.target == null || e.target == undefined) {
        element = e.path[0];
      } else {
        element = e.target;
      }
      this.Visible = false;
      setTimeout(() => {
        this.Loading = true;
        this.Element = "";
      }, 250);
    },
    SetVisible() {
      this.$root.$on("Modal", (Mode, Element) => {
        this.Mode = Mode;
        this.Element = Element;
        this.Visible = true;
      });
    },
    RequireElement(Mode, Element) {
      var el;
      try {
        if (Mode == "Detalle") {
          el = require("@/assets/Images/Modal/" + Element);
        } else {
          el = Element.url;
        }
      } catch (error) {
        //console.log("%c" + "Modal/" + Element, "color:red");
        if (Mode == "Detalle") {
          el = require("@/assets/Images/Global/Error.webp");
        } else {
          el = "https://3drender.es/";
        }
      }
      return el;
    },
  },
};
</script>

<style lang="scss" scoped>
.modal {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  z-index: 100000000;
  opacity: 0;
  pointer-events: none;
  width: 100dvw;
  height: 100dvh;
  background-color: rgb(0, 0, 0, 0.7);
  -webkit-transition: opacity 0.25s ease-in-out;
  -moz-transition: opacity 0.25s ease-in-out;
  -ms-transition: opacity 0.25s ease-in-out;
  -o-transition: opacity 0.25s ease-in-out;
  transition: opacity 0.25s ease-in-out;
  &__option {
    background-image: url("@/assets/Images/Global/Transparente.webp");
    background-position: center;
    background-repeat: no-repeat;
    background-size: 125px;
    width: 90dvw;
    max-width: 900px;
    height: 90dvh;
    max-height: 900px;
    -webkit-transition: background-image 0.35s ease-in-out;
    -moz-transition: background-image 0.35s ease-in-out;
    -ms-transition: background-image 0.35s ease-in-out;
    -o-transition: background-image 0.35s ease-in-out;
    transition: background-image 0.35s ease-in-out;
    &__item {
      opacity: 1;
      width: 100%;
      height: 100%;
      -webkit-transition: opacity 0.35s ease-in-out;
      -moz-transition: opacity 0.35s ease-in-out;
      -ms-transition: opacity 0.35s ease-in-out;
      -o-transition: opacity 0.35s ease-in-out;
      transition: opacity 0.35s ease-in-out;
    }
  }
  &__image {
    background-image: url("@/assets/Images/Global/Transparente.webp");
    background-position: center;
    background-repeat: no-repeat;
    background-size: 125px;
    max-width: 600px;
    max-height: 600px;
    width: 90dvw;
    height: 90dvh;
    -webkit-transition: background-image 0.35s ease-in-out;
    -moz-transition: background-image 0.35s ease-in-out;
    -ms-transition: background-image 0.35s ease-in-out;
    -o-transition: background-image 0.35s ease-in-out;
    transition: background-image 0.35s ease-in-out;
    &__item {
      opacity: 1;
      width: 100%;
      height: 100%;
      object-fit: contain;
      -webkit-transition: opacity 0.35s ease-in-out;
      -moz-transition: opacity 0.35s ease-in-out;
      -ms-transition: opacity 0.35s ease-in-out;
      -o-transition: opacity 0.35s ease-in-out;
      transition: opacity 0.35s ease-in-out;
    }
  }
  &__share {
    max-width: 550px;
    width: 85%;
    max-height: 440px;
    height: auto;
    background-color: white;
    border-radius: 5px;
    padding: 25px;
    &__items {
      display: flex;
      flex-wrap: wrap;
      flex-direction: row;
      justify-content: space-evenly;
      align-items: center;
      &__item {
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 10px;
        transform: scale(1);
        cursor: pointer;
        width: 60px;
        height: 60px;
        margin: 10px;
        -webkit-transition: all 0.35s ease-in-out;
        -moz-transition: all 0.35s ease-in-out;
        -ms-transition: all 0.35s ease-in-out;
        -o-transition: all 0.35s ease-in-out;
        transition: all 0.35s ease-in-out;
        &:not(:first-child) {
          transform: scale(1);
          margin-left: 10px;
          -webkit-transition: all 0.35s ease-in-out;
          -moz-transition: all 0.35s ease-in-out;
          -ms-transition: all 0.35s ease-in-out;
          -o-transition: all 0.35s ease-in-out;
          transition: all 0.35s ease-in-out;
        }
        &:hover {
          transform: scale(1.1);
          -webkit-transition: all 0.35s ease-in-out;
          -moz-transition: all 0.35s ease-in-out;
          -ms-transition: all 0.35s ease-in-out;
          -o-transition: all 0.35s ease-in-out;
          transition: all 0.35s ease-in-out;
        }
      }
    }
  }
  &.visible {
    opacity: 1;
    pointer-events: visible;
    -webkit-transition: opacity 0.25s ease-in-out;
    -moz-transition: opacity 0.25s ease-in-out;
    -ms-transition: opacity 0.25s ease-in-out;
    -o-transition: opacity 0.25s ease-in-out;
    transition: opacity 0.25s ease-in-out;
  }
  &.loading {
    & .modal {
      &__option {
        background-image: url("@/assets/Images/Global/Loader.svg") !important;
        -webkit-transition: background-image 0.35s ease-in-out;
        -moz-transition: background-image 0.35s ease-in-out;
        -ms-transition: background-image 0.35s ease-in-out;
        -o-transition: background-image 0.35s ease-in-out;
        transition: background-image 0.35s ease-in-out;
        &__item {
          opacity: 0;
          -webkit-transition: opacity 0.35s ease-in-out;
          -moz-transition: opacity 0.35s ease-in-out;
          -ms-transition: opacity 0.35s ease-in-out;
          -o-transition: opacity 0.35s ease-in-out;
          transition: opacity 0.35s ease-in-out;
        }
      }
      &__image {
        background-image: url("@/assets/Images/Global/Loader.svg") !important;
        -webkit-transition: background-image 0.35s ease-in-out;
        -moz-transition: background-image 0.35s ease-in-out;
        -ms-transition: background-image 0.35s ease-in-out;
        -o-transition: background-image 0.35s ease-in-out;
        transition: background-image 0.35s ease-in-out;
        &__item {
          opacity: 0;
          -webkit-transition: opacity 0.35s ease-in-out;
          -moz-transition: opacity 0.35s ease-in-out;
          -ms-transition: opacity 0.35s ease-in-out;
          -o-transition: opacity 0.35s ease-in-out;
          transition: opacity 0.35s ease-in-out;
        }
      }
    }
  }
}
</style>

<style>
.modal__share__items__item i {
  height: 35px;
  filter: invert(100%);
}
.icon-email {
  content: url("@/assets/Images/Global/Email.png");
}
.icon-linkedin {
  content: url("@/assets/Images/Global/LinkedIn.svg");
}
.icon-twitter {
  content: url("@/assets/Images/Global/Twitter.svg");
}
.icon-whatsapp {
  content: url("@/assets/Images/Global/WhatsApp.svg");
}
.icon-copy {
  content: url("@/assets/Images/Global/Copy.png");
}
</style>
